









































































import { Vue, Component } from 'vue-property-decorator';
import { FileType } from '@/common/ts/enum';
import Uploader from './components/Uploader.vue';
import { saveData } from './api/api';
import { Toast, Popup, Dialog, Col } from 'vant';
import { autoOpenApp } from '@/common/ts/common';
import { appShare, wxShareInfo, isWeiXin } from '@/common/ts/common';

Vue.use(Toast).use(Popup);
@Component({
  components: {
    Uploader,
  },
})
export default class Register extends Vue {
  pointOut = false;
  cover: any = '';
  videoCover: any = '';
  videoUrl: any = '';
  company: any = '';
  name: any = '';
  tel: any = '';
  desc: any = '';
  listType: any = '';
  FileType = FileType;
  uploadImg: any = true;
  registerData: any = {};
  showSuccessWords = false;
  timer: any = '';
  counter: any = '';
  changeValue(event: any) {
    if (event.target.selectedOptions[0].text === '平面类') {
      this.uploadImg = true;
      this.listType = '平面类';
      this.videoCover = '';
      this.videoUrl = '';
    } else {
      this.uploadImg = false;
      this.listType = '视频类';
      this.cover = '';
    }
    // console.log(event.target.selectedOptions[0].text);
  }

  getOssImagesUrls(result: any) {
    this.cover = result;
    console.log('check callback count');
    console.log('result', result, this.cover);
  }
  getOssVideoUrls(result: any) {
    this.videoUrl = result;
    console.log('result', result, this.videoUrl);
  }
  getOssVideoImagesUrls(result: any) {
    this.videoCover = result;
    console.log('videoCover', result, this.videoCover);
  }
  startCommit() {
    clearTimeout(this.counter);
    this.counter = setTimeout(() => {
      this.submitContent();
    }, 1000);
  }
  submitContent() {
    if (isWeiXin() === true) {
      Dialog.confirm({
        title: '友情提示',
        message: '请在上游新闻App进行投票',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        closeOnClickOverlay: true,
      })
        .then(() => {
          window.location.href =
            'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
        })
        .catch(() => {
          if (isWeiXin() === true) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
    } else {
      if (window.udid) {
        if (!/^[1][3,4,5,7,8,9,6][0-9]{9}$/.test(this.tel)) {
          return Toast({
            type: 'fail',
            duration: 3000,
            message: '请输入正确的手机号码',
          });
        }

        if (this.listType === '平面类') {
          if (
            this.name &&
            this.company &&
            this.cover &&
            this.cover.length &&
            this.tel &&
            this.desc
          ) {
            this.registerData = {
              title: this.name,
              work_type: this.listType,
              subtitle: this.company,
              cover: this.cover,
              phone: this.tel,
              content: this.desc,
              udid: window.udid,
              appkey: window.appkey,
            };
            saveData(this.registerData).then((res: any) => {
              if (res.code === 200) {
                Toast({
                  type: 'success',
                  duration: 3000,
                  message: '提交成功，请等待工作人员审核',
                });

                this.showSuccessWords = true;
                this.goToList();
              } else {
                return Toast({
                  type: 'fail',
                  duration: 3000,
                  message: res.msg,
                });
              }
            });
          } else {
            Toast({
              type: 'fail',
              duration: 3000,
              message: '请填写所有项目',
            });
          }
        } else if (
          this.listType === '视频类'
        ) {
          if (
            this.name &&
            this.company &&
            this.videoUrl &&
            this.videoUrl.length &&
            this.videoCover &&
            this.videoCover.length &&
            this.tel &&
            this.desc
          ) {
              this.registerData = {
              title: this.name,
              work_type: this.listType,
              subtitle: this.company,
              video_url: this.videoUrl,
              cover: this.videoCover,
              phone: this.tel,
              content: this.desc,
              udid: window.udid,
              appkey: window.appkey,
              };
              saveData(this.registerData).then((res: any) => {
                if (res.code === 200) {
                  Toast({
                    type: 'success',
                    duration: 3000,
                    message: '提交成功，请等待工作人员审核',
                  });
                  this.showSuccessWords = true;
                  this.goToList();
                } else {
                  return Toast({
                    type: 'fail',
                    duration: 3000,
                    message: res.msg,
                  });
                }
              });
          } else {
            Toast({
              type: 'fail',
              duration: 3000,
              message: '请填写所有项目',
            });
          }
        } else {
          Toast({
              type: 'fail',
              duration: 3000,
              message: '请填写所有项目',
            });
        }
      }
    }
  }
  goToList() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.$router.push('./list');
    }, 2000);
  }
  created() {
    autoOpenApp();
    // 分享
    appShare({
      title: ' 首届重庆市“吃得文明”主题活动公益广告创作大赛',
      url: window.location.href,
      subtitle: ' 首届重庆市“吃得文明”主题活动公益广告创作大赛',
      classId: -1,
      id: -1,
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    wxShareInfo({
      title: ' 首届重庆市“吃得文明”主题活动公益广告创作大赛',
      subtitle: ' 首届重庆市“吃得文明”主题活动公益广告创作大赛',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
}
